<template>
  <div>
    <MasterLayout>
      <section class="mt-3 full__row_section">
        <div class="row">
          <div class="col-md-12">
            <div class="dashboard__card large_card m_height indus_back_img_lg">
              <div class="row make-row-hundred-percent">
                <div class="col-md-3" style="display: flex">
                  <div class="mt-4 ml-4">
                    <router-link
                      :to="{
                        name: 'industrial_branch_order_management',
                        query: {
                          branchId: this.$route.query.branchId,
                          companyId: this.$route.query.companyId,
                          groupId: this.$route.query.groupId,
                        },
                      }"
                      class="back_button vue_router_link btn btn_theme theme_text white_bg"
                    >
                      <img
                        src="@/assets/img/arrow.svg"
                        width="20px"
                        class="mr-3"
                      />
                      {{ $t("text.iTrackOrder.back") }}
                    </router-link>
                  </div>
                </div>
                <div class="col-md-6 remove-padding-left order_header_wrapper">
                  <div class="">
                    <h4 class="text-white m_text_header">{{ orderId }}</h4>
                  </div>
                  <div class="mt-2">
                    <h5 class="mt-1 yellow_text">{{ orderDetails.status }}</h5>
                  </div>
                  <div class="mt-2">
                    <small class="mt-1 date_header text-white">{{
                      orderDetails.date
                    }}</small>
                  </div>
                  <div
                    class="progress_bar_wrapper mt-2"
                    style="margin: 0 auto; width: 34.6%"
                  >
                    <div class="progress_step active_progress_step"></div>
                    <div class="progress_rod_wrapper">
                      <div class="progress_rod"></div>
                    </div>
                    <div
                      class="progress_step"
                      :class="[
                        orderDetails.status === 'Payment Completed'
                          ? 'active_progress_step'
                          : null,
                      ]"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="full__row_section mt-3 pb-5">
        <div class="order_details_wrapper">
          <h6 class="background_central_header text-center pt-3">
            {{ $t("text.iTrackOrder.statusUpdates") }}
          </h6>
          <div class="text-center mt-3">
            <span class="background_central_header">
              {{ orderDetails.quantity }} {{ $t("text.iTrackOrder.litres") }}
              {{ orderDetails.productName }} (
              <!-- {{ $n(orderDetails.amount, 'currency') }} -->
              {{ industryBranch ? industryBranch.currencyCode : "" }}
              {{ convertThousand(orderDetails.amount) }}
              )
            </span>
            <div class="mt-3">
              <span class="mr-3 from_text"
                >{{ $t("text.iTrackOrder.from") }}:
              </span>
              <span class="order_branch">{{ industryBranchnName }}</span>
            </div>
            <div class="mt-3">
              <span class="mr-3 from_text"
                >{{ $t("text.iTrackOrder.to") }}:
              </span>
              <span class="order_branch">{{ orderDetails.companyName }}</span>
            </div>
          </div>
          <div class="order_list_wrapper mt-5">
            <div class="order_list_container mt-3">
              <div class="order_list_item order_list_text">
                <b>{{ $t("text.iTrackOrder.date") }}</b>
              </div>
              <div class="order_list_item order_list_text">
                <b>{{ $t("text.iTrackOrder.comment") }}</b>
              </div>
              <div class="order_list_item order_list_text">
                <b>{{ $t("text.iTrackOrder.status") }}</b>
              </div>
            </div>
          </div>
          <div class="order_list_wrapper mt-4">
            <div
              class="order_list_container mt-3"
              v-for="(ft, i) in orderDetails.fulfillmentTrack"
              :key="i"
            >
              <div class="order_list_item order_list_text">{{ ft.date }}</div>
              <div class="order_list_item order_list_text">
                {{ ft.comment }}
              </div>
              <div class="order_list_item order_list_text">
                {{ ft.orderAction }}
              </div>
            </div>
          </div>
        </div>
      </section>
    </MasterLayout>
  </div>
</template>
<script>
import Vue from "vue";
import MasterLayout from "@/views/Industrial/MasterLayout.vue";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import { Chart } from "highcharts-vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import backImg from "@/assets/img/pattern_img.png";
import { VueApexCharts } from "apexcharts";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";

import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Track Order:: Epump Industrial Portal",
  name: "Track Order",
  components: {
    MasterLayout,
    Highcharts: Chart,
    VueApexCharts,
    VueperSlides,
    VueperSlide,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      showLoader: false,
      TanksFilledCount: 0,
      branchDetails: localStorage.getItem("totalBranches")
        ? JSON.parse(localStorage.getItem("totalBranches"))
        : null,
      backImg,
      orderDetails: { amount: 0 },
      orderId: "",
      showLoader: false,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      industryBranch: null,
      industryBranchId: null,
    };
  },
  created() {
    this.$eventHub.$on("industryBranch", (industryBranch) => {
      this.industryBranch = industryBranch;
      document.title = "Industry Dashboard";
    });
  },
  watch: {
    industryBranch: function (newIndustry, oldIndustry) {
      if (newIndustry.id !== null) {
        this.industryBranchId = newIndustry.id;
      }
    },
  },
  computed: {
    industryBranchnName() {
      return this.branchDetails[0].name;
    },
  },
  mounted() {
    this.getOrderDetails();
  },
  methods: {
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    getOrderDetails() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/Order/${this.$route.query.id}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.orderDetails = response.data;
          this.orderDetails.date = this.$moment(response.data.date).format(
            "MMMM D, YYYY"
          );
          this.orderDetails.modifiedDate = this.$moment(
            response.data.modifiedDate
          ).format("h:mm A");
          this.orderDetails.quantity = this.convertThousand(
            response.data.quantity
          );
          this.orderDetails.fulfillmentTrack.forEach((el) => {
            el.date = this.$moment(el.date).format("MMMM D, YYYY h:mm A");
          });
          this.orderId = response.data.fulfillmentTrack[0].id;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
  },
};
</script>
